import React from 'react';

import { isOwnerClientId } from '../../helpers/clientContext';
import { callCenters, passwordReset } from '../../helpers/errors';
import styles from './FormError.module.scss';
import { FormErrorCallCenter } from './FormErrorCallCenter';
import { FormErrorPasswordReset } from './FormErrorPasswordReset';

type FormErrorProps = {
  error: {
    message: string;
    showCallCenter: boolean;
    showResetPassword: boolean;
    clientId?: string;
  };
};

export const FormError = ({
  error: { clientId = '', message, showCallCenter, showResetPassword },
}: FormErrorProps) => {
  const callCenter = isOwnerClientId(clientId) ? callCenters.owners : callCenters.haven;

  return (
    <div id="error" className={styles.flash}>
      <p>{message}</p>
      {showCallCenter && (
        <FormErrorCallCenter message={callCenter.message} number={callCenter.number} />
      )}
      {showResetPassword && (
        <FormErrorPasswordReset
          message={passwordReset.message}
          passwordResetText={passwordReset.passwordResetText}
          passwordResetLink={passwordReset.passwordResetLink}
        />
      )}
    </div>
  );
};
